export const environment = {
  production: true,
  serverUrl: "http://v3.pdm-plants-textures.com",
  imageBase: "http://v3.pdm-plants-textures.com/images/",
  fileData: "http://v3.pdm-plants-textures.com/filedatamin.json"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts